import { Container, Table, Title } from '@mantine/core';
import { ICurrency } from '../../../../libraries/currencies';
import { EquipCurrencyDenom } from '../../../../libraries/dashboardV2';
import { formatCurrAmount } from '../../../utils/script';
import { useSelector } from 'react-redux';
import { AppState } from '../../../client-redux/reducers';
import { Language } from '../../../languages/languageHandler';

interface DashboardSafeTableProps {
  currencyInfo: EquipCurrencyDenom;
  currencyMatch: ICurrency;
}

const DashboardSafeTable = ({ currencyInfo, currencyMatch }: DashboardSafeTableProps) => {
  const lang = useSelector<AppState, Language>(state => state.lang.lang);

  return (
    <Container className="dashboard-table-container">
      <Title order={2} className="dashboard-table-title">
        {lang.GLOBAL_SAFE}
      </Title>

      <Table withRowBorders className="dashboard-table">
        <Table.Thead>
          <Table.Tr>
            <Table.Th className="dashboard-table-header">{lang.GLOBAL_TYPE}</Table.Th>
            <Table.Th className="dashboard-table-header total">Total</Table.Th>
            <Table.Th className="dashboard-table-header quantity">{lang.GLOBAL_QUANTITY_MIN}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          <Table.Tr>
            <Table.Td className="dashboard-currency-table-denom">{lang.GLOBAL_BILLS}</Table.Td>
            <Table.Td className="dashboard-currency-table-value">
              {formatCurrAmount(currencyInfo.totalAmountSafeBills, currencyMatch)}
            </Table.Td>
            <Table.Td className="dashboard-currency-table-value">{`(${currencyInfo.totalQtySafeBills})`}</Table.Td>
          </Table.Tr>
          <Table.Tr>
            <Table.Td className="dashboard-currency-table-denom">{lang.GLOBAL_COINS}</Table.Td>
            <Table.Td className="dashboard-currency-table-value">
              {formatCurrAmount(currencyInfo.totalAmountSafeCoins, currencyMatch)}
            </Table.Td>
            <Table.Td className="dashboard-currency-table-value">{`(${currencyInfo.totalQtySafeCoins})`}</Table.Td>
          </Table.Tr>
        </Table.Tbody>
      </Table>
    </Container>
  );
};

export default DashboardSafeTable;
